export default __webpack_public_path__ + "images/ed8550ec2ef32a22e9815981e5d2d941.png";